export default __webpack_public_path__ + "static/soehne-web-leicht-08924947bc36c99f5361f21ce6188d3d.woff2";